export function generateOnPress({
  navigate,
  recordsName,
  setSelectedFilterParam,
  filterParams,
}: any) {
  return () =>
    navigate('records-filter-screen', {
      recordsName,
      setSelectedFilterParam,
      filterParams,
    });
}
